import React, { useState } from 'react';
import { useForm } from 'react-hook-form';
import { ArrowRight } from 'phosphor-react';
import { Link, useLocation } from 'react-router-dom';
import { Bezel, Button, Input, Eyebrow } from '_ui';

export function ResetPassword() {
    const [loading, setLoading] = useState(false);
    const [done, setDone] = useState(false);
    const [error, setError] = useState('');
    const { register, handleSubmit, formState: { errors } } = useForm();

    const query = new URLSearchParams(useLocation().search);
    const token = query.get('token');

    async function onSubmit({ password }) {
        setLoading(true);
        setError('');
        try {
            const res = await fetch('/api/auth/reset_password', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ token, password }),
            });
            const data = await res.json();
            if (data.status === 'Success') {
                setDone(true);
            } else {
                setError(data.message?.description || data.message || 'Có lỗi xảy ra');
            }
        } catch {
            setError('Không thể kết nối máy chủ');
        }
        setLoading(false);
    }

    if (!token) {
        return (
            <div className="flex min-h-[100dvh] items-center justify-center px-6 py-12">
                <div className="w-full max-w-md">
                    <Bezel className="px-8 py-10 text-center">
                        <h2 className="font-serif text-2xl text-espresso">Liên kết không hợp lệ</h2>
                        <p className="mt-3 text-sm text-espresso-soft/80">Liên kết đặt lại mật khẩu bị thiếu hoặc đã hết hạn.</p>
                        <Link to="/login" className="mt-6 inline-block text-sm text-brass-deep hover:underline">
                            ← Quay lại đăng nhập
                        </Link>
                    </Bezel>
                </div>
            </div>
        );
    }

    return (
        <div className="flex min-h-[100dvh] items-center justify-center px-6 py-12">
            <div className="w-full max-w-md">
                <Bezel className="px-8 py-10">
                    <Eyebrow className="mb-5">Đặt lại mật khẩu</Eyebrow>
                    <h2 className="font-serif text-3xl text-espresso">Mật khẩu mới</h2>
                    <p className="mt-2 text-sm text-espresso-soft/80">Nhập mật khẩu mới (ít nhất 8 ký tự).</p>

                    {done ? (
                        <div className="mt-8 space-y-4">
                            <p className="text-sm text-green-700">Đặt lại mật khẩu thành công!</p>
                            <Link to="/login" className="text-sm text-brass-deep hover:underline">
                                → Đăng nhập với mật khẩu mới
                            </Link>
                        </div>
                    ) : (
                        <form onSubmit={handleSubmit(onSubmit)} className="mt-8 space-y-5">
                            <Input
                                label="Mật khẩu mới"
                                type="password"
                                placeholder="••••••••"
                                autoComplete="new-password"
                                error={errors.password?.message}
                                {...register('password', {
                                    required: 'Vui lòng nhập mật khẩu',
                                    minLength: { value: 8, message: 'Mật khẩu phải có ít nhất 8 ký tự' },
                                })}
                            />
                            {error && <p className="text-sm text-red-600">{error}</p>}
                            <Button type="submit" icon={ArrowRight} loading={loading} className="w-full justify-between" size="lg">
                                {loading ? 'Đang xử lý…' : 'Đặt lại mật khẩu'}
                            </Button>
                        </form>
                    )}
                </Bezel>
            </div>
        </div>
    );
}
